/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
const EXPLORATION_CAPABILITY = 'canUseExploration';

function hasCapability(glassContext) {
	const {
		capabilities = []
	} = glassContext.services.userProfile;

	return capabilities.indexOf(EXPLORATION_CAPABILITY) !== -1;
}
export {
	hasCapability
};



// WEBPACK FOOTER //
// ./src/js/util/CapabilityUtil.js